import { BasicColumnTypes } from '@opengov/ogql-types';
import { ConstantReportColumnRecord, EReportConstant } from '@opengov/reporting-types';

import { EConditionalCustomValues } from './types';

export const getOptionsForValuesToCompare = (ifValueType = BasicColumnTypes.Numeric) => {
  return columnTypeCalculables[ifValueType].types;
};

export const getOptionsForOptionalSecondValueToCompare = (ifValueType = BasicColumnTypes.Numeric) => {
  return columnTypeCalculables[ifValueType].types;
};

export const columnTypeCalculables = {
  [BasicColumnTypes.Text]: {
    types: [BasicColumnTypes.Text],
    custom: {}
  },
  [BasicColumnTypes.Currency]: {
    types: [BasicColumnTypes.Currency],
    custom: {
      type: EConditionalCustomValues.Currency,
      label: 'Custom Value'
    }
  },
  [BasicColumnTypes.Numeric]: {
    types: [BasicColumnTypes.Numeric],
    custom: {
      type: EConditionalCustomValues.Numeric,
      label: 'Custom Value'
    }
  },
  [BasicColumnTypes.Percent]: {
    types: [BasicColumnTypes.Percent],
    custom: {
      type: EConditionalCustomValues.Percentage,
      label: 'Custom Value'
    }
  },
  [BasicColumnTypes.Date]: {
    types: [BasicColumnTypes.Date],
    custom: {
      type: EConditionalCustomValues.Date,
      label: 'Custom Date'
    }
  },
  [BasicColumnTypes.Year]: {
    types: [BasicColumnTypes.Year],
    custom: {
      type: EConditionalCustomValues.Year,
      label: 'Custom Value'
    }
  },
  [BasicColumnTypes.DayInterval]: {
    types: [BasicColumnTypes.DayInterval, BasicColumnTypes.Numeric],
    custom: {
      type: EConditionalCustomValues.Numeric,
      label: 'Custom Value'
    }
  },

  [BasicColumnTypes.YearInterval]: {
    types: [BasicColumnTypes.YearInterval, BasicColumnTypes.Numeric],
    custom: {
      type: EConditionalCustomValues.Numeric,
      label: 'Custom Value'
    }
  }
};

export const customColumnRecords = {
  [EConditionalCustomValues.Currency]: ConstantReportColumnRecord({
    name: EConditionalCustomValues.Currency,
    displayName: 'Custom Value',
    type: BasicColumnTypes.Currency,
    unit: EReportConstant.Number
  }),
  [EConditionalCustomValues.Date]: ConstantReportColumnRecord({
    name: EConditionalCustomValues.Date,
    displayName: 'Custom Date',
    type: BasicColumnTypes.Date,
    unit: EReportConstant.Date
  }),
  [EConditionalCustomValues.Numeric]: ConstantReportColumnRecord({
    name: EConditionalCustomValues.Numeric,
    displayName: 'Custom Value',
    type: BasicColumnTypes.Numeric,
    unit: EReportConstant.Number
  }),
  [EConditionalCustomValues.Percentage]: ConstantReportColumnRecord({
    name: EConditionalCustomValues.Percentage,
    displayName: 'Custom Value',
    type: BasicColumnTypes.Percent,
    unit: EReportConstant.Percentage
  }),
  [EConditionalCustomValues.Year]: ConstantReportColumnRecord({
    name: EConditionalCustomValues.Year,
    displayName: 'Custom Value',
    type: BasicColumnTypes.Year,
    unit: EReportConstant.Year
  })
};
